import { useIntl } from 'react-intl';

import MeditationIcon from 'icons/meditation-icon.inline.svg';
import MoreIcon from 'icons/more-icon.inline.svg';
import MusicIcon from 'icons/music-icon.inline.svg';
import SleepIcon from 'icons/sleep-icon.inline.svg';

import messages from './messages';
import {
	BodyText,
	Bullet,
	BulletCopy,
	ComputerContainer,
	Content,
	DesktopComputer,
	FeatureList,
	Grid,
	Icon,
	MobileDevice,
	Subheading,
	WhatYouGetTitle,
	Wrapper,
} from './styles';

const WhatYouGet = () => {
	const { formatMessage } = useIntl();
	const items = [
		{
			heading: formatMessage(messages.item1Heading),
			description: formatMessage(messages.item1Description),
			icon: <SleepIcon />,
		},
		{
			heading: formatMessage(messages.item2Heading),
			description: formatMessage(messages.item2Description),
			icon: <MeditationIcon />,
		},
		{
			heading: formatMessage(messages.item3Heading),
			description: formatMessage(messages.item3Description),
			icon: <MusicIcon />,
		},
		{
			heading: formatMessage(messages.item4Heading),
			description: formatMessage(messages.item4Description),
			icon: <MoreIcon />,
		},
	];

	return (
		<Wrapper>
			<Grid>
				<Content>
					<MobileDevice src="/_n/images/thomas/thomas-landing-device-mobile.webp" />
					<WhatYouGetTitle>{formatMessage(messages.whatYouGetTitle)}</WhatYouGetTitle>
					<FeatureList>
						{items.map(item => (
							<Bullet key={item.heading}>
								<Icon>{item.icon}</Icon>
								<BulletCopy>
									<Subheading>{item.heading}</Subheading>
									<BodyText>{item.description}</BodyText>
								</BulletCopy>
							</Bullet>
						))}
					</FeatureList>
				</Content>
				<ComputerContainer>
					<DesktopComputer src="/_n/images/thomas/thomas-landing-device-desktop.webp" />
				</ComputerContainer>
			</Grid>
		</Wrapper>
	);
};

export default WhatYouGet;
